import { IComplex, IDeveloper } from './complexes';

export interface IRole {
  '@context': string;
  '@id': string;
  '@type': string;
  id: number;
  name: TypeOfRole;
}
export interface IUsersBase {
  '@context': string;
  '@id': string;
  '@type': string;
  id: number;
}
export interface IUsers extends IUsersBase {
  email: string;
  iconUri: string|null;
  language: string;
  role: IRole|null;
  username: string;
  complexes: IComplex[];
  developers: IDeveloper[];
}

export type IComplexUser = Partial<IUsers>;

export enum TypeOfRole {
  superadmin = 'ROLE_SUPER_ADMIN',
  admin = 'ROLE_ADMIN',
  supervisor = 'ROLE_SUPERVISOR',
  manager = 'ROLE_MANAGER',
  partner = 'ROLE_PARTNER',
  rootadmin = 'ROLE_ROOT_ADMIN',
}
